import React, { useState, useEffect } from "react";
import { Modal, Form } from "react-bootstrap";
import CloseBtn from "assets/icons/Close.svg";
import AuthService from "services/auth.service";
import SmsReminderService from "services/sms-reminder.service";
import TimePicker from "react-bootstrap-time-picker";
import EditBtn from "assets/icons/Edit.svg";
import PreviewBackground from "assets/backgrounds/device.svg";

export function EditModal(props) {
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);

  const [errorMsgOne, setErrorMsgOne] = useState("");
  const [errorMsgTwo, setErrorMsgTwo] = useState("");

  // Form
  const [DaysBeforeAppointment, setDaysBeforeAppointment] = useState(
    props?.data?.days_before
  );
  const [SmsContent, setSmsContent] = useState(props?.data?.body);
  const [Time, setTime] = useState(props?.data?.time);
  const [Enable, setEnable] = useState(props?.data?.is_enabled);
  const [SmsContentLimit, setSmsContentLimit] = useState(120);

  // Preview
  const [SmsHeader] = useState(props?.sms_header);
  const [SmsContentPreview, setSmsContentPreview] = useState("");
  const [SmsContentCount, setSmsContentCount] = useState("");
  const [countColor, setCountColor] = useState("black");

  useEffect(() => {
    previewMessage(SmsContent);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClose = () => {
    setShow(false);
    setErrorMsgOne("");
    setErrorMsgTwo("");
    setCountColor("black");
    setSmsContent(props?.data?.body);
    previewMessage(props?.data?.body);
  };

  const handleSubmit = () => {
    setErrorMsgOne("");
    setErrorMsgTwo("");

    const validInput = validateInput(DaysBeforeAppointment, SmsContent);

    if (!validInput) {
      return null;
    }

    const parameters = {
      days_before_appointment: DaysBeforeAppointment,
      sms_content: SmsContent,
      time: Time,
      is_enabled: Enable,
    };

    SmsReminderService.updateSmsReminder(props.data.id, parameters).then(
      () => {
        window.location.reload();
      },
      (error) => {
        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace("/eb/login");
        }
      }
    );
  };

  const validateInput = () => {
    if (!DaysBeforeAppointment && DaysBeforeAppointment !== 0) {
      setErrorMsgOne("This field is required!");
    }

    if (!SmsContent) {
      setErrorMsgTwo("This field is required!");
    }

    const re = /^[\x00-\x7F]+$/; //eslint-disable-line

    if (!re.test(String(SmsContent).toLowerCase())) {
      setErrorMsgTwo("Invalid characters detected.");
    }

    if (SmsContentCount > 120) {
      setErrorMsgTwo("Total character count has exceeded the limit!");
      return null;
    }

    if (
      (!DaysBeforeAppointment && DaysBeforeAppointment !== 0) ||
      !SmsContent
    ) {
      return null;
    }
    return true;
  };

  const previewMessage = (message) => {
    setErrorMsgTwo("");
    const re = /^[\x00-\x7F]+$/; //eslint-disable-line

    if (message.length > 0 && !re.test(String(message).toLowerCase())) {
      setErrorMsgTwo("Invalid characters detected.");
    }

    var MaxCount = 120;

    var Name = message.match(/\{name\}/g);
    if (Name) {
      MaxCount = MaxCount - Name.length * 5;
    }

    var Date = message.match(/\{date\}/g);
    if (Date) {
      MaxCount = MaxCount - Date.length * 4;
    }

    var Time = message.match(/\{time\}/g);
    if (Time) {
      MaxCount = MaxCount - Time.length * 1;
    }

    var Day = message.match(/\{day\}/g);
    if (Day) {
      MaxCount = MaxCount - Day.length * 1;
    }

    setSmsContentLimit(MaxCount);

    var preview_message = message
      .replace(/\{name\}/g, "Sebastian A")
      .replace(/\{date\}/g, "2023-01-01")
      .replace(/\{time\}/g, "10:30pm")
      .replace(/\{day\}/g, "Sunday");
    setSmsContentPreview(`${SmsHeader}${preview_message}`);

    setSmsContentCount(preview_message.length);

    if (preview_message.length > 120) {
      setCountColor("red");
    } else {
      setCountColor("black");
    }
  };

  return (
    <div>
      <img
        src={EditBtn}
        alt="edit"
        className=" px-2 clickable"
        onClick={handleShow}
      />
      <Modal
        show={show}
        onHide={handleClose}
        keyboard={false}
        size="xl"
        centered
      >
        <Modal.Header className="d-block">
          <h3>Edit Sms Reminder</h3>
          <button type="button" className="close" onClick={handleClose}>
            <img src={CloseBtn} alt="modal-close" />
          </button>
        </Modal.Header>

        <Modal.Body className="d-block">
          <div className="row">
            <div className="mb-3 col-md-8">
              <div className="font-size-8 fweight-400 pt-3 p-2">Time</div>
              <div className="font-size-6 fweight-400 flex-grow-1">
                <TimePicker
                  start="05:00"
                  end="23:00"
                  step={60}
                  onChange={setTime}
                  value={Time}
                  className="rounded-pill"
                />
              </div>
              <hr />
              <div className="font-size-8 fweight-400 pt-3 p-2">
                Days Before Appointment *
              </div>
              <div className="font-size-6 fweight-400 flex-grow-1">
                <input
                  id="days-before"
                  name="days-before"
                  type="number"
                  min={0}
                  value={DaysBeforeAppointment}
                  onChange={(e) => setDaysBeforeAppointment(e.target.value)}
                  className="form-control py-6 px-4 rounded-pill w-100"
                />
                <p className="text-danger mt-2 text-left" role="alert">
                  {errorMsgOne}
                </p>
              </div>
              <hr />

              <div className="font-size-7 fweight-400 pt-3 p-2">
                Sms Content *
              </div>

              <div className="flex-grow-1">
                <textarea
                  id="sms-content"
                  name="sms-content"
                  type="area"
                  value={SmsContent}
                  onChange={(e) => {
                    setSmsContent(e.target.value);
                    previewMessage(e.target.value);
                  }}
                  className="form-control py-6 px-4 rounded-lg w-100 font-size-6 fweight-400"
                  maxLength={SmsContentLimit}
                  rows="3"
                />
              </div>
              <div className="pl-2 pt-2">
                <p style={{ color: "#868686" }}>
                  shortcodes: {"{name}"} , {"{date}"} , {"{time}"} , {"{day}"}
                </p>
                <p className="text-danger mt-2 text-left" role="alert">
                  {errorMsgTwo}
                </p>
              </div>
              <hr />
              <Form.Check inline>
                <Form.Check.Input
                  id="sms-reminder-enable"
                  name="sms-reminder-enable"
                  type="checkbox"
                  checked={Enable}
                  onChange={(e) => {
                    setEnable(e.target.checked);
                  }}
                />
                <Form.Check.Label className="checkbox-label">
                  Enable Now
                </Form.Check.Label>
              </Form.Check>
              <br />
              <button
                className="btn btn-danger rounded-pill py-3 px-5 float-right"
                type="button"
                onClick={() => {
                  handleSubmit();
                }}
              >
                Update
              </button>
            </div>
            <div className="mb-3 col-md-4">
              <div
                className="container d-flex preview-container"
                style={{ backgroundImage: `url(${PreviewBackground})` }}
              >
                <div className="preview-chatbox">
                  <div className="chatbox-content">
                    <p>{SmsContentPreview}</p>
                  </div>
                </div>
              </div>
              <div className="text-center" style={{ color: countColor }}>
                <p>Total character count: ( {SmsContentCount} / 120 )</p>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
